import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Gibt die Design-System-Showcase nur frei, wenn das Build-Zeit-Flag
 * environment.showDesignSystem gesetzt ist (local/dev/beta-test).
 * In kundenseitigen Builds (staging/demo/release) → Redirect auf das Dashboard.
 * TODO(design-system): temporär – vor Merge nach main entfernen oder freischalten.
 */
export const designSystemEnabledGuard: CanActivateFn = () => {
  const router = inject(Router);
  return environment.showDesignSystem ? true : router.parseUrl('/dashboard/welcome');
};
